import { FC } from "react";
import type { WheelRaffleWinner } from "../model/types";
import { formatRaffleDate } from "./formatRaffleDate";
import { RaffleUserCell } from "./RaffleUserCell";

import styles from "./RaffleTable.module.css";

interface Props {
  winners: WheelRaffleWinner[];
  // Сквозная нумерация между страницами.
  offset?: number;
}

export const WinnersTable: FC<Props> = ({ winners, offset = 0 }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <th>#</th>
        <th>User ID</th>
        <th>Drawn</th>
        <th className={styles.numeric}>Prize, USDT</th>
      </tr>
    </thead>
    <tbody>
      {winners.map((winner, index) => (
        // Один fid может занять несколько призовых мест.
        <tr key={`${winner.fid}-${index}`}>
          <td className={styles.index}>{offset + index + 1}</td>
          <td>
            <RaffleUserCell fid={winner.fid} />
          </td>
          <td>{formatRaffleDate(winner.created_at)}</td>
          <td className={styles.numeric}>{winner.prize_usdt}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
